module.exports = __webpack_public_path__ + "static/img/soft_1.0c7f589.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/soft_1.png
// module id = URud
// module chunks = 0